const fields = ['headId', 'trailerId'];
const text = value => String(value || '').trim();
const normalize = value => text(value).replace(/[\s-]/g, '').toUpperCase();

export function resolveOrderVehiclePlates(order = {}, driver = {}) {
  return {
    ...Object.fromEntries(fields.map(field => [field, text(order[field]) || text(driver?.[field])])),
    plateSources: Object.fromEntries(fields.map(field => [field, text(order[field]) ? 'ORDER' : 'DRIVER'])),
  };
}

export function orderPlateFormValue(truck, field) {
  return truck?.plateSources?.[field] === 'DRIVER' ? '' : text(truck?.[field]);
}

export function orderPlateWarnings(order = {}, driver = {}) {
  return fields.filter(field => normalize(order[field]) && normalize(driver?.[field])
    && normalize(order[field]) !== normalize(driver[field]))
    .map(field => ({field, orderPlate: order[field], driverPlate: driver[field]}));
}
